import { useState, useEffect } from 'react';

import { gql, useQuery } from '@apollo/client';

export interface ClientListOptions extends SelectItem {
}

interface ClientNameRecord {
  name: string;
}

interface ClientResults {
  allClients: {
    nodes: Array<ClientNameRecord>;
  };
}

const query = gql`
  query getClients {
    allClients {
      nodes {
        name
      }
    }
  }
`;

const useClientList = (): ClientListOptions[] => {
  const [clientNames, setClientNames] = useState<ClientListOptions[]>([]);
  const { data, loading, error } = useQuery<ClientResults>(query);

  useEffect(() => {
    if (!loading && !error && data) {
      const names = data.allClients.nodes.map((d: ClientNameRecord) => ({
        label: d.name,
        value: d.name,
      }));
      names.sort((a, b) => a.label.localeCompare(b.label));
      setClientNames(names);
    }
  }, [data, loading, error]);

  return clientNames;
};

export default useClientList;
